import {
  Backdrop,
  Box,
  CircularProgress,
  Drawer,
  Grid2,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { CustomCheckbox } from "../../Components/Common/CustomCheckbox";

import React, { useEffect, useState } from "react";
import { colors } from "../../theme/theme";
import { SecondaryBtn } from "../Common/CustomBtn";
import {
  Close,
  East,
  EmailOutlined,
  UploadOutlined,
  PersonOutline,
  Today,
  PhoneOutlined,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { CustomInputLabel } from "../Creators/CustomInputLabel";
import { CustomTextArea, CustomInput } from "../Common/CustomInput";
import {
  getAllPosts,
  subscribeToContent,
} from "../../redux/actions/posts.dispatcher";
import { ErrorSnackbar } from "../Common/CustomSnackbar";
import { getSubscriptionOfUser } from "../../redux/actions/subscriptions.dispatcher";
import { createExerciseEvent } from "../../redux/actions/user.dispatcher";

import FileUpload from "../Common/FileUpload";
import { CustomDropDown } from "../Common/CustomDropdown";

const interestLabels = {
  jiuJitsu: "Jiu-Jitsu",
  boxing: "Boxing",
  muaythai: "Muay Thai",
  wrestling: "Wrestling",
  kickboxing: "Kickboxing",
  mma: "MMA Training",
  strength: "Strength & Conditioning",
  mental: "Mental & Recovery",
  fighter: "Fighter Lifestyle",
};

const AddEventDrawer = ({
  drawerState,
  setDrawerState,
  paidVideoData,
  setSuccess,
  creatorData,
  type,
}) => {
  const creator = type === "video" ? paidVideoData?.creator : creatorData;
  const { userData } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [uploadUrl, setUploadUrl] = useState(null);
  const [fullName, setFullName] = useState(userData?.firstName || "");
  const [email, setEmail] = useState(userData?.email || "");
  const [cardHolderName, setcardHolderName] = useState("");
  const [cardNumber, setcardNumber] = useState("");
  const [expiryDate, setexpiryDate] = useState("");
  const [cvv, setcvv] = useState("");

  const [subscriptionDetails, setSubscriptionDetails] = useState(null);

  const [eventFormData, setEventFormData] = useState({
    userId: userData.id,
    name: "",
    description: "",
    level: "",
    category: [],
    plan: "",
    duration: "",
    price: "",
    participants: "",
    deadline: null,
    startDateTime: null,
    endDate: null,
  });

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleCreateEvent = async () => {
    setErrorState({ error: false, message: "" });
    if (!eventFormData.name || !eventFormData.description) {
      setErrorState({
        error: true,
        message: "Required fields cannot be empty",
      });
      return;
    }

    try {
      setLoading(true);

      const response = await createExerciseEvent({
        ...eventFormData,
        mediaURL: uploadUrl,
      });
      if (response) {
        setEventFormData({
          userId: userData.id,
          name: "",
          description: "",
          level: "",
          category: [],
          plan: "",
          duration: "",
          price: "",
          participants: "",
          deadline: null,
          startDateTime: null,
          endDate: null,
        });
        setDrawerState(false);
        setSuccess(true);
      }
    } catch (error) {
      console.log(error);
      setErrorState({ error: true, message: error.message });
    } finally {
      setLoading(false);
      setDrawerState(false);
    }
  };

  const getSubscription = async () => {
    if (type === "creator" && drawerState) {
      const response = await getSubscriptionOfUser(creator?.creatorProfile?.id);

      setSubscriptionDetails(response);
    }
  };

  const handleEventFormChange = (field, value) => {
    setEventFormData({ ...eventFormData, [field]: value });
  };

  const mediumScreen = useMediaQuery("(max-width:960px)");

  useEffect(() => {
    getSubscription();
  }, [drawerState]);

  return (
    <Drawer
      anchor={"right"}
      open={drawerState}
      sx={{
        "& .MuiDrawer-paper": {
          width: "75%",
          border: "1px solid #000",
          backgroundColor: "#fff",
        },
      }}
      onClose={() => setDrawerState(false)}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Snackbar */}
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 4,
            py: 2,
            borderBottom: "1px solid #000",
          }}
        >
          <Typography
            sx={{
              fontSize: "23px",
              fontFamily: "Inter-SemiBold",
              color: colors.textColor,
            }}
          >
            Create Exercise Event
          </Typography>
          <Stack
            direction="row"
            alignItems={"center"}
            sx={{
              width: "50%",
              gap: 2,
              justifyContent: "flex-end",
            }}
          >
            <SecondaryBtn
              onClick={() => setDrawerState(false)}
              text="Close"
              Icon={Close}
              noMb
              noMt
              width="20%"
            />
            <SecondaryBtn
              onClick={handleCreateEvent}
              text="Create"
              Icon={East}
              noMb
              noMt
              width="30%"
              filled
            />
          </Stack>
        </Box>

        <Grid2 container spacing={2} sx={{ mt: 3, px: 4, pb: 4 }}>
          <Grid2 item size={{ xs: 12, md: 3 }}>
            <CustomInputLabel text="Upload Media" required />
            <FileUpload
              fileType="image"
              setUploadUrl={setUploadUrl}
              uploadUrl={uploadUrl}
              setLoading={setLoading}
            />
          </Grid2>
          <Grid2 item size={{ xs: 12, md: 9 }}>
            <Grid2 container spacing={mediumScreen ? 0 : 2}>
              <Grid2 item size={{ xs: 12, md: 12 }}>
                <CustomInputLabel text="Title" required />
                <CustomInput
                  value={eventFormData.name}
                  setValue={(value) => handleEventFormChange("name", value)}
                  noIcon
                  placeholder="e.g., Arm-Bar Drills"
                />
              </Grid2>
            </Grid2>
            <Grid2 container spacing={mediumScreen ? 0 : 2}></Grid2>
            <Box>
              <CustomInputLabel text="Description" required />
              <CustomTextArea
                noIcon
                value={eventFormData.description}
                setValue={(value) =>
                  handleEventFormChange("description", value)
                }
                placeholder="e.g. Drawing Added: Circle around kick target."
              />
            </Box>
            <Grid2 container spacing={2}>
              {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="Skill Level" required />
                <CustomDropDown
                  value={eventFormData.level}
                  setValue={(value) => handleEventFormChange("level", value)}
                  title="e.g. Beginner, Intermediate, Advanced"
                  label="e.g. Beginner, Intermediate, Advanced"
                  data={[
                    { id: 1, label: "Beginner", value: "Beginner" },
                    { id: 2, label: "Intermediate", value: "Intermediate" },
                    { id: 3, label: "Advanced", value: "Advanced" },
                  ]}
                  noIcon
                  noMt
                />
              </Grid2> */}
              <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="Category" required />
                <CustomCheckbox
                  options={Object.values(interestLabels)}
                  selectedValues={eventFormData.category}
                  onChange={(selected) =>
                    handleEventFormChange("category", selected)
                  }
                  multiple
                />
              </Grid2>
              {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="Duration" required />
                <CustomDropDown
                  value={eventFormData.duration}
                  setValue={(value) => handleEventFormChange("duration", value)}
                  title="e.g. 5, 10, 15, 30 minutes, etc"
                  label="e.g. 5, 10, 15, 30 minutes, etc"
                  data={[
                    { id: 1, label: "5 minutes", value: "5 minutes" },
                    { id: 2, label: "10 minutes", value: "10 minutes" },
                    { id: 3, label: "15 minutes", value: "15 minutes" },
                    { id: 3, label: "30 minutes", value: "30 minutes" },
                  ]}
                  noIcon
                  noMt
                />
              </Grid2> */}
              {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="Subscription Plan" required />
                <CustomDropDown
                  value={eventFormData.plan}
                  setValue={(value) => handleEventFormChange("plan", value)}
                  title="e.g. Free, Paid, VIP Access"
                  label="e.g. Free, Paid, VIP Access"
                  data={[
                    { value: "freeToEveryone", label: "Free to everyone" },

                    {
                      value: "payPerViewToEveryone",
                      label: "Pay per View for everyone",
                    },
                    {
                      value: "payPerView",
                      label: "Pay Per View only for subscriber",
                    },
                    { value: "paid", label: "Paid - only for subscribers" },
                  ]}
                  noIcon
                  noMt
                />
              </Grid2> */}
              {/* {(eventFormData.plan === "payPerView" ||
                eventFormData.plan === "payPerViewToEveryone") && (
                <Grid2 item size={{ xs: 12, md: 6 }}>
                  <CustomInputLabel text="Price" required />
                  <CustomInput
                    value={eventFormData.price}
                    setValue={(value) => handleEventFormChange("price", value)}
                    noIcon
                    placeholder="e.g., 10"
                  />
                </Grid2>
              )} */}
              {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="Enrollment Deadline" required />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={eventFormData.deadline} // Bind value to state
                    onChange={(value) =>
                      handleEventFormChange("deadline", value)
                    }
                    sx={{
                      height: "52.5px",
                      width: "100%",
                      borderRadius: "0px",
                      border: "1px solid #000",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                        borderWidth: "0px",
                      },
                      "& .MuiSelect-icon": {
                        color: "#00000080",
                      },
                      "& .Mui-focused": {
                        borderColor: "transparent",
                        border: "none",
                      },
                      "& .MuiInputAdornment-root": {
                        color: "#00000080",
                      },
                      fontFamily: "Inter-Regular",
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  />
                </LocalizationProvider>
              </Grid2> */}
              {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="Max Participants" required />
                <CustomDropDown
                  value={eventFormData.participants}
                  setValue={(value) =>
                    handleEventFormChange("participants", value)
                  }
                  title="e.g. 5, 10, 15, 20 participants"
                  label="e.g. 5, 10, 15, 20 participants"
                  data={[
                    { id: 1, label: "5 participants", value: "5 participants" },
                    {
                      id: 1,
                      label: "10 participants",
                      value: "10 participants",
                    },
                    {
                      id: 1,
                      label: "15 participants",
                      value: "15 participants",
                    },
                    {
                      id: 1,
                      label: "20 participants",
                      value: "20 participants",
                    },
                  ]}
                  noIcon
                  noMt
                />
              </Grid2> */}
              <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="Start Date & Time" required />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={
                      eventFormData.startDateTime
                        ? dayjs(eventFormData.startDateTime)
                        : null
                    }
                    onChange={(value) =>
                      handleEventFormChange("startDateTime", value)
                    }
                    sx={{
                      height: "52.5px",
                      width: "100%",
                      borderRadius: "0px",
                      border: "1px solid #000",
                    }}
                  />
                </LocalizationProvider>
              </Grid2>
              {/* <Grid2 item size={{ xs: 12, md: 6 }}>
                <CustomInputLabel text="End Date (Recommended)" required />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={eventFormData.endDate} // Bind value to state
                    onChange={(value) =>
                      handleEventFormChange("endDate", value)
                    }
                    sx={{
                      height: "52.5px",
                      width: "100%",
                      borderRadius: "0px",
                      border: "1px solid #000",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                        borderWidth: "0px",
                      },
                      "& .MuiSelect-icon": {
                        color: "#00000080",
                      },
                      "& .Mui-focused": {
                        borderColor: "transparent",
                      },
                      "& .MuiInputAdornment-root": {
                        color: "#00000080",
                      },
                      fontFamily: "Inter-Regular",
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  />
                </LocalizationProvider>
              </Grid2> */}
            </Grid2>
          </Grid2>
        </Grid2>
      </Box>
    </Drawer>
  );
};

export default AddEventDrawer;
